export default __webpack_public_path__ + "static/media/packageImg.a26a2a0f.png";